import { useNavigate } from 'react-router-dom';

const trackClick = (source: string) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'for_sale_click', { source });
  }
};

const ForSaleHeroBanner = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    trackClick('hero_banner');
    navigate('/for-sale');
  };

  return (
    <div className="w-full bg-gradient-to-r from-red-600 via-red-600 to-red-700 py-3 px-4">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
            <i className="ri-alarm-warning-fill text-yellow-300 text-xl"></i>
          </div>
          <div>
            <p className="text-white font-bold text-sm sm:text-base leading-tight">
              This Website Is For Sale
            </p>
            <p className="text-red-100 text-xs sm:text-sm leading-tight">
              Acquire this fully built SEO traffic asset — monetized &amp; turnkey
            </p>
          </div>
        </div>
        <button
          onClick={handleClick}
          className="flex-shrink-0 bg-white text-red-600 font-bold text-sm px-5 py-2 rounded-lg hover:bg-red-50 transition-colors cursor-pointer whitespace-nowrap border-2 border-white shadow"
        >
          View Details →
        </button>
      </div>
    </div>
  );
};

export default ForSaleHeroBanner;
